import { fetchTermsOfUse, downloadTermsOfUse } from './actions/terms-of-use.actions';

const mapStateToThis = ({ session, termsOfUse, config }) => {
  const { locale } = session;
  const { content, isLoading, hasError, attachments } = termsOfUse;
  const applicationName = config.applicationName[locale];

  return {
    locale,
    content,
    isLoading,
    hasError,
    applicationName,
    attachments,
  };
};

const mapDispatchToThis = {
  fetchTermsOfUse,
  downloadTermsOfUse
};

@Inject('$ngRedux', '$sce')
export class RwTermsOfUseDialogController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  $onInit() {
    return this.fetchTermsOfUse();
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-terms-of-use/components/rw-terms-of-use-dialog-controller.js